import { serviceInstance } from "utils/axiosInstances";
import { getResourcesBucket } from "config";

/** Short-lived (5 min) signed URL for viewing a file in the resources bucket. */
export async function getResourceUrl(key: string): Promise<string> {
  const response = await serviceInstance.post<{ url: string }>("/presignedGET", {
    bucket: getResourcesBucket(),
    key,
    timeout: 300,
  });
  return response.data.url;
}
